/* eslint-disable promise/prefer-await-to-callbacks */
import { RefObject, useEffect, useRef } from 'react'

type Callback<T> = (el: T) => void

type Result<T> = RefObject<T>

export function useElementResize<T extends HTMLElement>(cb: Callback<T>): Result<T> {
  const ref = useRef<T>(null)
  const cbRef = useRef(cb)
  cbRef.current = cb

  useEffect(() => {
    const el = ref.current
    if (!el) {
      return
    }

    const observer = new ResizeObserver(([entry]) => {
      if (!entry) {
        return
      }

      cbRef.current(entry.target as T)
    })

    observer.observe(el)

    return () => {
      observer.disconnect()
    }
  }, [])

  return ref
}
